module.exports = __webpack_public_path__ + "assets/img/star_sentence_select10.01255754.png";